import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringEducationalExcellence from "./sections/EmpoweringEducationalExcellence";
import TheGrowthBlueprint from "./sections/TheGrowthBlueprint";
import TheKerryMethod from "./sections/TheKerryMethod";
import PartnersInGrowth from "./sections/PartnersInGrowth";
import ReadyToScale from "./sections/ReadyToScale";
import SiteReadyFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringEducationalExcellence />
      <TheGrowthBlueprint />
      <TheKerryMethod />
      <PartnersInGrowth />
      <ReadyToScale />
      <SiteReadyFooter />
    </div>;
}